import React from "react";
import Helmet from "react-helmet";
import { SEO_TAGS } from "../constants";
import { SEOTags } from "GlobalComponent/SEOTags";

export const SeoTags = React.memo(() => {
  const seoProps = {
    title: SEO_TAGS.TITLE,
    canonical: `${CW_HOST_URL}/`,
    alternate: SEO_TAGS.ANDROID_ALTERNATE,
    description: SEO_TAGS.DESCRIPTION,
  };
  return <SEOTags {...seoProps} />;
});
SeoTags.displayName = "SeoTags";
